import * as actionTypes from "actions/fulfillment/types/wro";

const INITIAL_STATE = {
  fetching: false,
  data: null,
  error: null,
};

export default function (state = INITIAL_STATE, action) {
  const { WRO_DELETE_REQUESTED, WRO_DELETE_SUCCESS, WRO_DELETE_ERRORED } = actionTypes;

  switch (action.type) {
    case WRO_DELETE_REQUESTED:
      return { ...state, fetching: true };
    case WRO_DELETE_SUCCESS:
      return { ...state, fetching: false, data: action.data, error: null };
    case WRO_DELETE_ERRORED:
      return { ...state, fetching: false, data: null, error: action.error };
    default:
      return state;
  }
}
